import styled from 'styled-components';

const TextAreaWrapper = styled.div` 
  max-height: 50%;
`;
TextAreaWrapper.displayName = 'TextAreaWrapper';

export default TextAreaWrapper;
